export const ENTITIES = '@@STATIC_PAGE/ENTITIES';

export enum SINGLE {
  REQUEST = '@@STATIC_PAGE/SINGLE/REQUEST',
  SUCCESS = '@@STATIC_PAGE/SINGLE/SUCCESS',
  FAILURE = '@@STATIC_PAGE/SINGLE/FAILURE'
}

export const STORE_RESET = '@@STORE/RESET';
